import { datadogRum } from '@datadog/browser-rum';

export const logDataDogError = (
	error: Error,
	errorName: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	context?: Record<string, any>
) => {
	const errorObject = new Error(error.message);
	errorObject.cause = error;
	errorObject.name = errorName;
	errorObject.stack = error.stack;
	datadogRum.addError(errorObject, { context });
};
